import { render, staticRenderFns } from "./instockMaterial.vue?vue&type=template&id=4ff56bc4&scoped=true&"
import script from "./instockMaterial.vue?vue&type=script&lang=js&"
export * from "./instockMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff56bc4",
  null
  
)

export default component.exports